import { GlobalStyles } from "@mui/material";

const GlobalStyle = () => (
  <GlobalStyles
    styles={{
      html: { height: "100%" },
      body: {
        height: "100%",
        margin: 0,
        overflow: "hidden",
      },
      "#root": {
        height: "100%",
      },
      ".MuiCardHeader-action .MuiIconButton-root": {
        padding: 4,
        width: 28,
        height: 28,
      },
    }}
  />
);

export default GlobalStyle;
